module.exports = __webpack_public_path__ + "static/img/logo_w.394e60bd.jpg";